export const AutoGrow = (element) => {
    element.style.height = '0px'
    var int = element.style.height.replace('px', '')
    if (int === '') int = 0
    if(element.scrollHeight >= int ){
        const new_height = "height: "+ (element.scrollHeight + 2) + "px !important"
        element.style = new_height
    }
    ;
}